import LazyLoad from 'vanilla-lazyload';
import MobileMenu from '../components/MobileMenu';
import Form from '../components/Form';

export default {
  init() {
    const lazyLoadOptions = {
      elements_selector: '.lazy',
    };

    /* eslint-disable */
    window.lazyLoadInstance = new LazyLoad(lazyLoadOptions);
    /* eslint-enable */

    // Menu toggle behaviour
    const mainNav = document.getElementById('js-main-nav-mobile');

    if ( mainNav ) {
      new MobileMenu(mainNav);
    }

    var scrollToTopBtn = document.querySelector('.scroll-to-top');

    scrollToTopBtn.addEventListener('click', scrollToTop);

    function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    // Handle form validation and submission
    const forms = document.getElementsByClassName('form');
    for ( let i = 0; i < forms.length; i++ ) {
      new Form(forms[i]);
    }

    /* eslint-disable */
    window.onloadCallback = function() {
      for ( let i = 0; i < forms.length; i++ ) {
        let captcha = forms[i].querySelector('.g-recaptcha');

        grecaptcha.render(captcha, {
          'sitekey' : scriptVars.recaptchaSiteKey
        });
      }
    }
    /* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js